<!-- <html>

<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>

<body>
  <br>
  <br>

  <h3 class="text-light text-center">
    <I>Your Account has been activated !
      <br><br>

      In case, there's any problem while login,
      <br><br>
      please contact <u>support@reliabledrs.com</u><br><br>

      <form #aForm="ngForm">

        <input name="email_id" [(ngModel)]="this['email_id']" type="hidden" #email_id="ngModel" class="form-control"
          required>
      </form>

      Now <a href='.#/login' class="text-white"> <u>Click here</u> </a> to Login
    </I>
  </h3>
</body>

</html> -->


<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative">
    <div class="container">
      <div class="row justify-content-center ">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <img src="/assets/images/sign-in.png" class="w-100" />
        </div>
        <div class="col-md-4 mt-4 mt-md-0">
          <p class="text-color font-size-30 font-weight-500">ACCOUNT ACTIVATION</p>
          <p class="text-change font-size-16 font-weight-400 pt-3 pb-2">Your Account has been activated successfully!
          </p>
          <p class="text-change font-size-16 font-weight-400">In case, if there's any problem while logging in,<br>
            please contact us at <a href="mailto:support@reliabledrs.com">support@reliabledrs.com</a></p>
          <form #aForm="ngForm">
            <input name="email_id" [(ngModel)]="this['email_id']" type="hidden" #email_id="ngModel" class="form-control"
              required>
          </form>
          <button type="button" class="btn btn-primary w-100 mt-4" routerLink='/login'>LOGIN</button>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>